import firebase from "firebase/app";
import "firebase/auth";

import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card";
import { CreateElement } from "vue";
import GlobalRules from "./rules";

@Component
export default class Login extends Vue {
  private rules = GlobalRules;

  private input: any = {};

  private _inputValid: boolean = false;

  render(h: CreateElement) {
    return (
      <v-container class="fill-height" fluid>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="accent" dark flat>
                <v-toolbar-title>Welcome to BalanceAI</v-toolbar-title>
              </v-toolbar>
              <v-form ref="form" v-model={this._inputValid}>
                <v-card-text>
                  <v-text-field
                    label="E-mail"
                    name="email"
                    rules={this.rules.email}
                    prepend-icon="mdi-account"
                    type="text"
                    v-model={this.input["email"]}
                    required
                    autocomplete
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    rules={this.rules.password}
                    hint="At least 8 characters"
                    v-model={this.input["password"]}
                    type="password"
                    required
                    counter="20"
                    autocomplete
                  ></v-text-field>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-btn color="accent" to="/student">
                  Sign Up
                </v-btn>
                <div class="flex-grow-1"></div>
                <v-btn
                  disabled={!this._formComplete()}
                  color="accent"
                  onclick={this._logUserIn}
                >
                  Log In
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    );
  }
  private _formComplete() {
    let form = this.$refs.form as any;
    return form && form.validate();
  }

  private _logUserIn() {
    if (!this.input.email || !this.input.password) return;

    firebase
      .auth()
      .signInWithEmailAndPassword(this.input.email, this.input.password)
      .then(data => {
        this.$store.subscribe((mutation: any, state: any) => {
          if (mutation.type == "SET_LOGGED_IN" && mutation.payload) {
            location.reload();
            this.$router.push({ name: "home" });
            this.$store.dispatch("addNotification", {
              type: "success",
              value: "Signed in successfuly.",
              timeout: 4000,
              icon: "mdi-account"
            });
          }
        });
      })
      .catch(err => {
        this.$store.dispatch("addNotification", {
          type: "error",
          value: "E-mail or password wrong. Please try again",
          timeout: 5000,
          icon: "mdi-account"
        });
      });
  }
}

const component = Login;
